'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (key) {
  key = key || sharedKey;

  !counterHash[key] && (counterHash[key] = 0);

  return counterHash[key]++;
};

var sharedKey = '@@shared';
var counterHash = {};

;

var clear = exports.clear = function clear() {
  counterHash = {};
};


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_bone-mv@0.1.20@@bone/bone-mv/lib/utils/unique-id.js
// module id = 999
// module chunks = 4